var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 385,
    viewBox: "0 0 350 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3064_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.173 222.651H81.3643V381.767H280.173V222.651Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.174 222.651L312.204 189.87L308.523 337.936L282.751 377.715L280.174 222.651Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3644 222.651L46.0205 283.056H238.939L280.174 222.651H81.3644Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.174 222.651L305.945 258.01L337.608 209.392L314.045 184.346L280.174 222.651Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1504 220.81L146.213 184.346H314.045L280.173 222.651L86.1504 220.81Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.628 222.651L46.0205 188.713L112.29 154.143L146.213 184.345L80.628 222.651Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.528 68.1806L170.085 35.3903C168.976 33.9601 166.917 33.7007 165.488 34.8108L162.161 37.3945C160.731 38.5047 160.472 40.564 161.582 41.9941L187.024 74.7845C188.133 76.2146 190.192 76.474 191.621 75.3639L194.949 72.7802C196.378 71.6701 196.637 69.6108 195.528 68.1806Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.145 48.6186C167.955 48.6186 178.339 38.2297 178.339 25.4143C178.339 12.5989 167.955 2.20996 155.145 2.20996C142.335 2.20996 131.95 12.5989 131.95 25.4143C131.95 38.2297 142.335 48.6186 155.145 48.6186Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.609 39.9708C163.844 39.9708 170.52 33.2922 170.52 25.0538C170.52 16.8153 163.844 10.1367 155.609 10.1367C147.374 10.1367 140.698 16.8153 140.698 25.0538C140.698 33.2922 147.374 39.9708 155.609 39.9708Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 17.753C151.236 16.9414 151.998 16.2936 152.888 15.8776C153.778 15.4616 154.764 15.2926 155.741 15.3884C159.025 15.8009 159.909 17.6646 159.909 17.6646",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 17.753C151.236 16.9414 151.998 16.2936 152.888 15.8776C153.778 15.4616 154.764 15.2926 155.741 15.3884C159.025 15.8009 159.909 17.6646 159.909 17.6646",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46 82.6447C285.144 81.7372 286.054 81.0259 287.1 80.5822C288.146 80.1385 289.29 79.978 290.418 80.1169C291.545 80.2557 292.617 80.689 293.524 81.3733C294.431 82.0575 295.142 82.9685 295.586 84.0148L303.869 103.565L312.146 123.123C312.588 124.17 312.748 125.314 312.608 126.442C312.469 127.57 312.035 128.641 311.351 129.548C310.667 130.455 309.756 131.166 308.71 131.609C307.665 132.052 306.521 132.212 305.393 132.074L284.327 129.473L263.268 126.873C262.143 126.732 261.074 126.298 260.169 125.615C259.264 124.931 258.555 124.021 258.112 122.977C257.669 121.932 257.508 120.79 257.645 119.664C257.783 118.537 258.213 117.467 258.894 116.56L271.677 99.6169L284.46 82.6447Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.742 91.3186C292.076 89.7259 291.056 88.1641 289.464 87.8302C287.872 87.4963 286.31 88.5167 285.977 90.1095L282.351 107.413C282.017 109.006 283.037 110.567 284.629 110.901C286.221 111.235 287.782 110.215 288.116 108.622L291.742 91.3186Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.839 123.955C285.482 123.955 287.625 121.812 287.625 119.167C287.625 116.523 285.482 114.379 282.839 114.379C280.196 114.379 278.053 116.523 278.053 119.167C278.053 121.812 280.196 123.955 282.839 123.955Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M183.715 202.761C184.624 201.934 185.394 200.966 185.997 199.896",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M186.793 192.772C185.04 183.401 176.116 170.473 188.869 145.302C191.733 139.645 187.22 114.798 187.927 104.875C188.552 95.9618 195.496 89.2215 198.508 83.9766",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.94 9.94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M199.833 80.5737C199.932 79.9648 199.892 79.3413 199.714 78.7504C199.537 78.1595 199.228 77.6167 198.81 77.1631",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M181.138 216.389C181.588 214.594 182.447 212.927 183.649 211.52",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M192.389 204.942C201.055 200.426 211.835 198.15 214.258 197.281C219.368 195.447 223.992 192.485 228.52 189.502C239.565 182.231 271.154 166.217 280.454 151.005",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "14.95 14.95"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M282.663 145.981C283.152 144.195 283.182 142.315 282.751 140.515",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.6365 52.1172H7.99654C4.80016 52.1172 2.20898 54.7095 2.20898 57.9072V99.3656C2.20898 102.563 4.80016 105.156 7.99654 105.156H65.6365C68.8329 105.156 71.4241 102.563 71.4241 99.3656V57.9072C71.4241 54.7095 68.8329 52.1172 65.6365 52.1172Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20898 61.6943H69.9514",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7223 58.6881C12.5031 58.6881 13.1361 58.0549 13.1361 57.2737C13.1361 56.4926 12.5031 55.8594 11.7223 55.8594C10.9416 55.8594 10.3086 56.4926 10.3086 57.2737C10.3086 58.0549 10.9416 58.6881 11.7223 58.6881Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.363 58.6881C18.1438 58.6881 18.7767 58.0549 18.7767 57.2737C18.7767 56.4926 18.1438 55.8594 17.363 55.8594C16.5822 55.8594 15.9492 56.4926 15.9492 57.2737C15.9492 58.0549 16.5822 58.6881 17.363 58.6881Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 58.6881C24.0344 58.6881 24.6674 58.0549 24.6674 57.2737C24.6674 56.4926 24.0344 55.8594 23.2536 55.8594C22.4728 55.8594 21.8398 56.4926 21.8398 57.2737C21.8398 58.0549 22.4728 58.6881 23.2536 58.6881Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3672 82.6191C26.3672 82.7363 26.2695 82.8145 26.0742 82.8535C25.9336 82.877 25.7383 82.8809 25.4883 82.8652C25.1367 82.8418 24.9883 82.8301 25.043 82.8301C24.7383 82.8301 24.5859 82.9824 24.5859 83.2871C24.5859 83.4746 24.5977 83.7598 24.6211 84.1426C24.6445 84.5176 24.6562 84.7988 24.6562 84.9863C24.6562 85.2598 24.5352 85.3965 24.293 85.3965C21.5977 85.3965 20.1797 85.3613 20.0391 85.291C19.8984 85.2285 19.8281 85.1465 19.8281 85.0449C19.8281 84.9277 19.875 84.6387 19.9688 84.1777C20.0703 83.7168 20.1211 83.3809 20.1211 83.1699C20.1211 82.9121 19.9766 82.7832 19.6875 82.7832C19.1641 82.7832 18.3789 82.7988 17.332 82.8301C16.293 82.8613 15.5117 82.877 14.9883 82.877C14.3633 82.877 14.0508 82.6309 14.0508 82.1387C14.0508 81.8887 14.0469 81.5176 14.0391 81.0254C14.0312 80.5254 14.0273 80.1504 14.0273 79.9004C14.0273 79.666 14.1484 79.4199 14.3906 79.1621C15.5312 77.9434 16.3633 76.9668 16.8867 76.2324C17.1367 75.8809 17.9844 74.5098 19.4297 72.1191C19.6172 71.7598 19.9219 71.2676 20.3438 70.6426C20.4531 70.5098 20.5703 70.4434 20.6953 70.4434C20.8828 70.4434 21.4609 70.584 22.4297 70.8652C23.4062 71.1465 24.0703 71.2871 24.4219 71.2871C24.6719 71.2871 24.7969 71.4473 24.7969 71.7676C24.7969 72.0723 24.7617 72.5332 24.6914 73.1504C24.6211 73.7598 24.5859 74.2207 24.5859 74.5332V79.4668C24.7344 79.4668 24.9922 79.4434 25.3594 79.3965C25.6875 79.3496 25.9414 79.3262 26.1211 79.3262C26.2695 79.3262 26.3438 79.416 26.3438 79.5957C26.3438 79.7598 26.332 80.0059 26.3086 80.334C26.293 80.6621 26.2852 80.9121 26.2852 81.084C26.2852 81.2559 26.2969 81.5137 26.3203 81.8574C26.3516 82.1934 26.3672 82.4473 26.3672 82.6191ZM20.5781 75.2129C20.5781 75.166 20.5508 75.1426 20.4961 75.1426C20.4258 75.1426 20.3555 75.1934 20.2852 75.2949C19.7852 76.0996 19.2852 76.9043 18.7852 77.709C18.1836 78.6387 17.5977 79.3848 17.0273 79.9473C17.457 79.9473 18.5508 79.8926 20.3086 79.7832C20.3242 79.4707 20.3789 78.7012 20.4727 77.4746C20.543 76.5059 20.5781 75.752 20.5781 75.2129ZM41.3555 78.1777C41.3555 80.1934 40.7031 81.9238 39.3984 83.3691C38.0469 84.8691 36.3711 85.6191 34.3711 85.6191C32.3711 85.6191 30.6992 84.8691 29.3555 83.3691C28.043 81.9238 27.3867 80.1934 27.3867 78.1777C27.3867 76.1543 28.043 74.4277 29.3555 72.998C30.6992 71.5215 32.3711 70.7832 34.3711 70.7832C36.3711 70.7832 38.043 71.5215 39.3867 72.998C40.6992 74.4355 41.3555 76.1621 41.3555 78.1777ZM37.0078 78.1777C37.0078 77.373 36.7734 76.6738 36.3047 76.0801C35.8047 75.4473 35.1602 75.1309 34.3711 75.1309C33.5664 75.1309 32.918 75.4434 32.4258 76.0684C31.9648 76.6465 31.7344 77.3496 31.7344 78.1777C31.7344 78.9902 31.9648 79.6973 32.4258 80.2988C32.9258 80.9473 33.5742 81.2715 34.3711 81.2715C35.1367 81.2715 35.7773 80.9395 36.293 80.2754C36.7695 79.666 37.0078 78.9668 37.0078 78.1777ZM54.7266 82.6191C54.7266 82.7363 54.6289 82.8145 54.4336 82.8535C54.293 82.877 54.0977 82.8809 53.8477 82.8652C53.4961 82.8418 53.3477 82.8301 53.4023 82.8301C53.0977 82.8301 52.9453 82.9824 52.9453 83.2871C52.9453 83.4746 52.957 83.7598 52.9805 84.1426C53.0039 84.5176 53.0156 84.7988 53.0156 84.9863C53.0156 85.2598 52.8945 85.3965 52.6523 85.3965C49.957 85.3965 48.5391 85.3613 48.3984 85.291C48.2578 85.2285 48.1875 85.1465 48.1875 85.0449C48.1875 84.9277 48.2344 84.6387 48.3281 84.1777C48.4297 83.7168 48.4805 83.3809 48.4805 83.1699C48.4805 82.9121 48.3359 82.7832 48.0469 82.7832C47.5234 82.7832 46.7383 82.7988 45.6914 82.8301C44.6523 82.8613 43.8711 82.877 43.3477 82.877C42.7227 82.877 42.4102 82.6309 42.4102 82.1387C42.4102 81.8887 42.4062 81.5176 42.3984 81.0254C42.3906 80.5254 42.3867 80.1504 42.3867 79.9004C42.3867 79.666 42.5078 79.4199 42.75 79.1621C43.8906 77.9434 44.7227 76.9668 45.2461 76.2324C45.4961 75.8809 46.3438 74.5098 47.7891 72.1191C47.9766 71.7598 48.2812 71.2676 48.7031 70.6426C48.8125 70.5098 48.9297 70.4434 49.0547 70.4434C49.2422 70.4434 49.8203 70.584 50.7891 70.8652C51.7656 71.1465 52.4297 71.2871 52.7812 71.2871C53.0312 71.2871 53.1562 71.4473 53.1562 71.7676C53.1562 72.0723 53.1211 72.5332 53.0508 73.1504C52.9805 73.7598 52.9453 74.2207 52.9453 74.5332V79.4668C53.0938 79.4668 53.3516 79.4434 53.7188 79.3965C54.0469 79.3496 54.3008 79.3262 54.4805 79.3262C54.6289 79.3262 54.7031 79.416 54.7031 79.5957C54.7031 79.7598 54.6914 80.0059 54.668 80.334C54.6523 80.6621 54.6445 80.9121 54.6445 81.084C54.6445 81.2559 54.6562 81.5137 54.6797 81.8574C54.7109 82.1934 54.7266 82.4473 54.7266 82.6191ZM48.9375 75.2129C48.9375 75.166 48.9102 75.1426 48.8555 75.1426C48.7852 75.1426 48.7148 75.1934 48.6445 75.2949C48.1445 76.0996 47.6445 76.9043 47.1445 77.709C46.543 78.6387 45.957 79.3848 45.3867 79.9473C45.8164 79.9473 46.9102 79.8926 48.668 79.7832C48.6836 79.4707 48.7383 78.7012 48.832 77.4746C48.9023 76.5059 48.9375 75.752 48.9375 75.2129Z",
    fill: "#4A9EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4239 119.889C79.5572 119.889 86.1505 113.292 86.1505 105.156C86.1505 97.019 79.5572 90.4229 71.4239 90.4229C63.2906 90.4229 56.6973 97.019 56.6973 105.156C56.6973 113.292 63.2906 119.889 71.4239 119.889Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5381 97.4209L83.5733 112.89",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2197 115.101L81.3643 94.4746",
    stroke: "#4A9EB9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.684 183.977C144.321 175.874 150.352 172.471 141.744 163.72C137.871 159.786 130.272 154.784 124.808 153.407C114.5 150.806 101.246 148.987 96.8278 147.514C92.1816 145.967 86.5192 140.884 82.8376 136.464C79.8922 132.884 81.306 127.013 81.792 122.836",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.286 144.161C221.857 143.74 222.499 141.041 221.72 138.133C220.941 135.225 219.036 133.209 217.465 133.63C215.894 134.051 215.252 136.75 216.03 139.658C216.809 142.566 218.714 144.582 220.286 144.161Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.279 139.014C229.092 137.604 227.638 135.242 225.032 133.736C222.426 132.231 219.654 132.153 218.841 133.562C218.027 134.972 219.481 137.335 222.087 138.84C224.693 140.345 227.465 140.423 228.279 139.014Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.198 135.365C219.619 133.793 217.604 131.887 214.697 131.108C211.79 130.329 209.092 130.972 208.671 132.543C208.25 134.115 210.266 136.021 213.172 136.801C216.079 137.58 218.777 136.937 219.198 135.365Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.122 134.517C221.537 133.703 221.464 130.92 219.96 128.301C218.455 125.682 216.088 124.218 214.673 125.032C213.258 125.845 213.33 128.628 214.835 131.247C216.339 133.867 218.706 135.33 220.122 134.517Z",
    stroke: "#4A9EB9",
    strokeWidth: 2.00689,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.848 136.268C223.011 133.103 224.934 129.897 224.143 129.106C223.353 128.315 220.147 130.239 216.984 133.403C213.821 136.568 211.898 139.774 212.689 140.565C213.479 141.356 216.685 139.432 219.848 136.268Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.943 135.491L218.55 138.092",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.589 132.884L221.673 134.969",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.042 183.942C342.614 183.521 343.256 180.822 342.477 177.914C341.698 175.006 339.793 172.99 338.222 173.411C336.651 173.832 336.008 176.531 336.787 179.439C337.566 182.347 339.471 184.363 341.042 183.942Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.041 178.787C349.855 177.378 348.401 175.015 345.795 173.51C343.189 172.004 340.417 171.927 339.604 173.336C338.79 174.745 340.244 177.108 342.85 178.613C345.456 180.119 348.228 180.196 349.041 178.787Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.961 175.14C340.382 173.568 338.366 171.662 335.46 170.883C332.553 170.103 329.855 170.746 329.434 172.318C329.013 173.89 331.028 175.796 333.935 176.575C336.842 177.354 339.54 176.712 339.961 175.14Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.018 173.757C341.427 172.943 341.349 170.17 339.844 167.562C338.34 164.955 335.978 163.501 334.569 164.315C333.161 165.128 333.238 167.902 334.743 170.509C336.248 173.116 338.609 174.57 340.018 173.757Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.606 176.045C343.769 172.881 345.692 169.674 344.901 168.883C344.11 168.092 340.905 170.016 337.742 173.18C334.579 176.345 332.656 179.551 333.446 180.343C334.237 181.134 337.443 179.21 340.606 176.045Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.702 175.27L339.309 177.87",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.347 172.662L342.43 174.747",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2663 153.004C75.1731 152.225 77.1882 150.319 76.7672 148.747C76.3462 147.175 73.6485 146.533 70.7417 147.312C67.8349 148.091 65.8198 149.997 66.2408 151.569C66.6618 153.141 69.3595 153.783 72.2663 153.004Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4489 146.94C72.9536 144.332 73.0313 141.559 71.6226 140.745C70.2139 139.932 67.8521 141.386 66.3475 143.993C64.8428 146.6 64.765 149.373 66.1738 150.187C67.5825 151.001 69.9443 149.547 71.4489 146.94Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4117 155.859C70.1906 152.951 69.5482 150.253 67.977 149.831C66.4058 149.41 64.5007 151.426 63.7218 154.334C62.9429 157.242 63.5853 159.941 65.1565 160.362C66.7277 160.783 68.6328 158.767 69.4117 155.859Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3448 155.045C65.951 153.54 67.4043 151.177 66.591 149.768C65.7777 148.358 63.0056 148.436 60.3995 149.941C57.7934 151.447 56.34 153.809 57.1533 155.219C57.9667 156.628 60.7387 156.55 63.3448 155.045Z",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1853 156.342C73.976 155.55 72.0529 152.344 68.8898 149.179C65.7267 146.015 62.5214 144.091 61.7307 144.882C60.9399 145.673 62.863 148.88 66.0261 152.044C69.1892 155.209 72.3945 157.133 73.1853 156.342Z",
    fill: "#303030",
    stroke: "#4A9EB9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1035 153.089L70.688 150.481",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5332 149.443L67.5802 147.329",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.917 158.82C81.9857 163.11 87.4919 166.853 93.3445 169.988C97.5932 172.264 102.041 174.238 105.906 177.119C109.772 179.999 126.524 202.069 127.385 206.813",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.203 168.529C199.963 165.852 203.071 162.36 205.296 158.315C207.521 154.269 208.804 149.774 209.052 145.163",
    stroke: "#0088B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.915 206.813C273.915 200.566 282.987 189.811 292.75 190.864C296.668 191.292 300.408 192.728 304.281 193.413C308.832 194.179 313.496 193.908 317.927 192.621C322.359 191.335 326.443 189.065 329.876 185.98",
    stroke: "#4A9EB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3064_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 385,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.3ee6332c5d22ef11686d667c54ae074a.svg";
export { ForwardRef as ReactComponent };